import { Stripe } from '@stripe/stripe-js'
import { IClientInfo } from '../../models/clientInfo'

export enum ConfigurationTypeKeys {
  CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
  FETCH_AREAS = 'FETCH_AREAS',
  FETCHING_AREAS = 'FETCHING_AREAS',
  FETCH_AREAS_SUCCESSFUL = 'FETCH_AREAS_SUCCESSFUL',
  SET_SELECTED_AREA = 'SET_SELECTED_AREA',
  FETCH_CLIENT_INFO = 'FETCH_CLIENT_INFO',
  FETCHING_CLIENT_INFO = 'FETCHING_CLIENT_INFO',
  FETCH_CLIENT_INFO_SUCCESSFUL = 'FETCH_CLIENT_INFO_SUCCESSFUL',
  SET_AREA_CHANGED = 'SET_AREA_CHANGED',
  RESET_AREA_CHANGED = 'RESET_AREA_CHANGED',
  SET_STRIPE = 'SET_STRIPE',
  CHECK_IF_SHOW_PAYMENT_METHOD = 'CHECK_IF_SHOW_PAYMENT_METHOD',
  SET_SHOW_PAYMENT_METHOD = 'SET_SHOW_PAYMENT_METHOD'
}

export interface IChangeLanguageAction {
  type: typeof ConfigurationTypeKeys.CHANGE_LANGUAGE
  payload: string
  [extraProps: string]: unknown
}

export interface IFetchAreasAction {
  type: typeof ConfigurationTypeKeys.FETCH_AREAS
  [extraProps: string]: unknown
}

export interface ISetIsFetchingAreasAction {
  type: typeof ConfigurationTypeKeys.FETCHING_AREAS
  [extraProps: string]: unknown
}

export interface IFetchAreasSuccessfulAction {
  type: typeof ConfigurationTypeKeys.FETCH_AREAS_SUCCESSFUL
  payload: any[]
  [extraProps: string]: unknown
}

export interface IFetchClientInfoAction {
  type: typeof ConfigurationTypeKeys.FETCH_CLIENT_INFO
  [extraProps: string]: unknown
}

export interface ISetIsFetchingClientInfoAction {
  type: typeof ConfigurationTypeKeys.FETCHING_CLIENT_INFO
  [extraProps: string]: unknown
}

export interface IFetchClientInfoSuccessfulAction {
  type: typeof ConfigurationTypeKeys.FETCH_CLIENT_INFO_SUCCESSFUL
  payload: IClientInfo
  [extraProps: string]: unknown
}

export interface ISetSelectedAreaAction {
  type: typeof ConfigurationTypeKeys.SET_SELECTED_AREA
  payload: number
  [extraProps: string]: unknown
}
export interface ISetAreaChangedAction {
  type: typeof ConfigurationTypeKeys.SET_AREA_CHANGED
  [extraProps: string]: unknown
}

export interface IResetAreaChangedAction {
  type: typeof ConfigurationTypeKeys.RESET_AREA_CHANGED
  [extraProps: string]: unknown
}

export interface ISetStripeAction {
  type: typeof ConfigurationTypeKeys.SET_STRIPE,
  payload: Stripe
  [extraProps: string]: unknown
}

export interface ICheckIfShowPaymentMethodAction {
  type: typeof ConfigurationTypeKeys.CHECK_IF_SHOW_PAYMENT_METHOD
  [extraProps: string]: unknown
}

export interface ISetShowPaymentMethodAction {
  type: typeof ConfigurationTypeKeys.SET_SHOW_PAYMENT_METHOD,
  payload: boolean
  [extraProps: string]: unknown
}

export type ConfigurationActionTypes =
  | IChangeLanguageAction
  | IFetchAreasAction
  | ISetIsFetchingAreasAction
  | IFetchAreasSuccessfulAction
  | ISetSelectedAreaAction
  | IFetchClientInfoSuccessfulAction
  | ISetAreaChangedAction 
  | IResetAreaChangedAction
  | ISetStripeAction
  | ICheckIfShowPaymentMethodAction
  | ISetShowPaymentMethodAction
